module.exports = __webpack_public_path__ + "/d841cd33efbbf60a070ef313f2271eee.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/feature_icons/modern_tools_icon.svg
 ** module id = 1541
 ** module chunks = 0
 **/